import { Component, signal } from '@angular/core';
import { LpMissionInfo } from '../../../typings/schema';
import { RidDemoPage } from '../../components/rid-demo-page/rid-demo-page';
import { RidGame } from '../../leerplus/rid-game';
import { ExpandableDataPackageProvider } from '../../leerplus/rid-game.utils';

@Component({
  selector: 'app-cockpit-page',
  imports: [RidDemoPage, RidGame],
  templateUrl: './cockpit-page.html',
})
export class CockpitPage {
  mission = signal<LpMissionInfo | undefined>(undefined);

  dataPackageProvider = new ExpandableDataPackageProvider('https://api.woordkr8.dev.gametailors.com/cas', 'p_kcGxFNoKRtJ7L7H6mMp0I', {
    url: 'https://api.woordkr8.dev.gametailors.com/auth',
    username: 'woordkr8-service',
    password: 'MKk1kYpp4xb0FLyEJ8uzprMw',
  });

  onMissionCompleted(uid: string) {
    if (this.mission()?.uid === uid) {
      this.mission.set(undefined);
    }
  }
}
